module.exports = __webpack_public_path__ + "static/media/IMG_5957.53b2d7d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/IMG_5957.jpg
// module id = 239
// module chunks = 1